import { useCallback, useMemo } from 'react';

import { useScreenQuery } from '@april9au/stack9-ui';

type RequirementDropdownProps = {
  countryTemplateId: number;
  setRequirement: any;
  requirement?: number;
};

const RequirementDropdown = ({
  countryTemplateId,
  setRequirement,
  requirement,
}: RequirementDropdownProps) => {
  const { data } = useScreenQuery<any>('getRequirementsByCountryTemplate', {
    vars: {
      countryTemplateId,
      page: 0,
      limit: 10,
    },
  });

  const options = useMemo(
    () =>
      data?.results?.map((opt: any) => ({
        label: opt.code,
        value: opt.id,
      })),
    [data],
  );

  const onChange = useCallback(() => {
    const selectedElement = document.getElementById('requirement_id') as any;
    setRequirement(selectedElement?.value);
  }, [setRequirement]);

  return (
    <div className="block text-sm  leading-6 text-gray-900">
      <label htmlFor="requirement_id">Requirement section</label>
      <div className="relative">
        <select
          required
          onChange={onChange}
          className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
          id="requirement_id"
          style={{ minWidth: '100%' }}
        >
          <option value="" disabled selected>
            Select requirement
          </option>

          {options &&
            options.map((opt: any) => (
              <option
                key={opt.value}
                selected={opt.value === requirement}
                value={opt.value}
              >
                {opt.label}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default RequirementDropdown;
